export default {
  "content": "<circle cx=\"50\" cy=\"50\" fill=\"none\" stroke=\"#D7D8DE\" stroke-width=\"10\" r=\"30\" stroke-dasharray=\"141.37166941154067 49.12388980384689\" transform=\"rotate(101.895 50 50)\"><animateTransform attributeName=\"transform\" type=\"rotate\" calcMode=\"linear\" values=\"0 50 50;360 50 50\" keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"/></circle>",
  "attrs": {
    "width": "14",
    "height": "14",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 100 100",
    "preserveAspectRatio": "xMidYMid",
    "style": "background:0 0"
  }
};